import styled from 'styled-components';

const FlexContainer = styled.div.withConfig({ componentId: 'sc-ugls2o-0' })`
  div > ul {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }
`;

export default FlexContainer;
